import { ISgeDashboardResponse } from '../../../../model/sge/dashboard/dashboard-response';

export type DashboardState = {
    dashboardData: ISgeDashboardResponse | null;
    loading: boolean;
    error: string | null;
};

export enum ACTION_TYPES {
    setDashboardData = 'setDashboardData',
    setLoading = 'setLoading',
    setError = 'setError',
}

export const DashboardReducer = (state: DashboardState, action: any): DashboardState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.setDashboardData:
            return { ...state, dashboardData: payload };
        case ACTION_TYPES.setLoading:
            return { ...state, loading: payload };
        case ACTION_TYPES.setError:
            return { ...state, error: payload };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
};
